(function ($) {
	$(function () { });

	$(window).load(function () {
		var $_body = $("body"),
			$_wrapper = $("#wrapper"),
			$_header = $("header"),
			$_ctBody = $(".content-body"),
			$_window = $(this),
			currentScrollTop = 0;

		function init() {
			disableClick();
			getRateElement();
			init_facybox();
			flyout_mobile();
			swiper_js();
			press_hover();
			tab_show();
			change_lang();
			clamp_content();
			mCustomScrollbar();
			backToTop();
			navSection();
			masonryJS();
			// popup_main();
		}
		init();

		function isIe() {
			var pattern = /Trident\/[0-9]+\.[0-9]+/;

			return pattern.test(navigator.userAgent);
		}

		function isEdge() {
			var pattern = /Edge\/[0-9]+\.[0-9]+/;
			pattern.test(navigator.userAgent);
		}

		function disableClick() {
			$(".noclick").on("click", function () {
				return false;
			});
		}

		function scrollToPosition(pos, second) {
			$("html, body").animate(
				{
					scrollTop: pos
				},
				second * 1000
			);
		}

		// Resize Height
		function setRateElement(objects, x, y) {
			var w = x || 5;
			var h = y || 3;
			// objects.height(objects.width() * h / w);
			objects.each(function () {
				$(this).height(($(this).outerWidth() * h) / w);
			});
		}

		function getRateElement() {
			setRateElement($(".imgResize-1-1"), 1, 1);
			setRateElement($(".imgResize-2-1"), 2, 1);
			setRateElement($(".imgResize-3-1"), 3, 1);
			setRateElement($(".imgResize-5-1"), 5, 1);
			setRateElement($(".imgResize-3-4"), 3, 4);
			setRateElement($(".imgResize-4-3"), 4, 3);
			setRateElement($(".imgResize-6-5"), 6, 5);
			setRateElement($(".imgResize-12-7"), 12, 7);
			setRateElement($(".imgResize-15-4"), 15, 5);
			setRateElement($(".imgResize-16-9"), 16, 9);
			setRateElement($(".imgResize-19-15"), 19, 15);
			setRateElement($(".imgResize-25-29"), 25, 29);
			setRateElement($(".imgResize-25-16"), 25, 16);
			setRateElement($(".imgResize-12-17"), 12, 17);
			setRateElement($(".imgResize-40-17"), 40, 17);
			setRateElement($(".imgResize-48-5"), 48, 5);
			setRateElement($(".imgResize-48-7"), 48, 7);
			setRateElement($(".imgResize-48-11"), 48, 11);
			setRateElement($(".imgResize-56-44"), 56, 44);
			setRateElement($(".imgResize-80-7"), 80, 7);
		}

		function mCustomScrollbar() {
			$(".wrapper-info .info .content").mCustomScrollbar({
				autoHideScrollbar: false
			});
		}

		// init_facybox
		function init_facybox() {
			if (typeof $.fancybox !== "undefined") {
				console.log("init_facybox");
				$(".fancybox-popup").each(function (index) {
					$(this).fancybox({
						toolbar: false,
						smallBtn: true,

						iframe: {
							preload: false
						},
						autoFocus: false,
						btnTpl: {
							smallBtn:
								'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
								'<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
								'</button>' +
								'<div class="fancybox-close-btn">' +
								'<div id="btn-closeIn"></div>' +
								'<div id="btn-closeOut"></div>' +
								'</div>'
						},
						afterShow: function (instance, slide) {
							var animation1 = lottie.loadAnimation({
								container: document.getElementById("btn-closeIn"),
								renderer: "svg",
								autoplay: true,
								path: "json/Close_in.json"
							});

							var animation2 = lottie.loadAnimation({
								container: document.getElementById("btn-closeOut"),
								renderer: "svg",
								autoplay: false,
								path: "json/Close_out.json"
							});

							$("#btn-closeIn").show();
							$("#btn-closeOut").hide();

							$(".fancybox-close-btn").hover(
								function () {
									$("#btn-closeIn").hide();
									$("#btn-closeOut").show();
									animation1.stop();
									animation2.play();
								},
								function () {
									$("#btn-closeIn").show();
									$("#btn-closeOut").hide();
									animation1.play();
									animation2.stop();
								}
							);
							$('.fancybox-close-btn').on("click", function () {
								$.fancybox.close();
							});

							var swiper = new Swiper('.swiper-popup', {
								slidesPerView: 1,
								navigation: {
									nextEl: ".swiper-button-next",
									prevEl: ".swiper-button-prev"
								}
							});

							$('#iframe_comment_popup .btn-submit').on('click', function () {
								console.log('clsjc');
								$.fancybox.close();
								$.fancybox.open({
									src: '#iframe_success_popup',
									opts: {
										toolbar: false,
										smallBtn: true,
										iframe: {
											preload: false
										},
										autoFocus: false,
										btnTpl: {
											smallBtn:
												'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
												'<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
												'</button>' +
												'<div class="fancybox-close-btn">' +
												'<div id="btn-closeIn"></div>' +
												'<div id="btn-closeOut"></div>' +
												'</div>'
										},
										afterShow: function () {

											var animation3 = lottie.loadAnimation({
												container: document.getElementById("btn-closeIn"),
												renderer: "svg",
												autoplay: true,
												path: "json/Close_in.json"
											});

											var animation4 = lottie.loadAnimation({
												container: document.getElementById("btn-closeOut"),
												renderer: "svg",
												autoplay: false,
												path: "json/Close_out.json"
											});

											$("#btn-closeIn").show();
											$("#btn-closeOut").hide();

											$(".fancybox-close-btn").hover(
												function () {
													$("#btn-closeIn").hide();
													$("#btn-closeOut").show();
													animation3.stop();
													animation4.play();
												},
												function () {
													$("#btn-closeIn").show();
													$("#btn-closeOut").hide();
													animation3.play();
													animation4.stop();
												}
											);

											getRateElement();
										}
									},
								});
								$('.fancybox-close-btn').on("click", function () {
									console.log('click');
									$.fancybox.close();
								});
							});

							getRateElement();
							mCustomScrollbar();
						}
					});

				});
			}
		}

		//Flyout Mobile
		function flyout_mobile(pos, second) {
			$('.navbar-hamburger').click(function () {
				$('.flyout-menu').addClass('open-nav');
				$('body').addClass('overlay-hidden');
			});

			$('.btn-menu-mobile').click(function () {
				$('.flyout-menu').removeClass('open-nav');
				$('body').removeClass('overlay-hidden');
				$('.flyout-menu .flyout-menu__main ul').find('.submenu-btn').removeClass('submenu-show');
				$('.flyout-menu .flyout-menu__main ul ul.sub-menu').slideUp();
			});

			$('.flyout-menu__main .menu-item').each(function () {
				var $_this = $(this);
				if ($_this.hasClass('menu-item-has-children')) {
					$_this.append('<span class="submenu-btn"><img src="img/icon_menu_arrow.png"/></span>');

					$_this.find('.submenu-btn').on('click', function () {
						if ($(this).hasClass('submenu-show')) {
							$(this).removeClass('submenu-show');
							$('.flyout-menu .flyout-menu__main ul ul.sub-menu').slideUp();
						} else {
							$('.flyout-menu .flyout-menu__main ul').find('.submenu-btn').removeClass('submenu-show');
							$(this).addClass('submenu-show');
							$('.flyout-menu .flyout-menu__main ul ul.sub-menu').slideUp();
							$_this.find('.sub-menu').slideDown();
						}
					});
				}
			});
		}

		// Swiper js
		function swiper_js() {
			var galleryThumbs = new Swiper(".gallery-thumbs", {
				slidesPerView: 4,
				loop: false,
				freeMode: true,
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
					1366: {
						slidesPerView: 3,
					}
				},
				on: {
					init: function () {
						getRateElement();

						$(".gallery-thumbs .swiper-slide").hover(
							function () {
								$(".gallery-thumbs .swiper-slide").removeClass("slider-item-hover");
								$(this).addClass("slider-item-hover");
							},
							function () {
								$(this).removeClass("slider-item-hover");
							}
						);
					}
				}
			});

			var ourHearts = new Swiper(".ourHearts-swiper", {
				slidesPerView: 5,
				spaceBetween: 6,
				slidesPerGroup: 6,
				loopFillGroupWithBlank: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				breakpoints: {
					768: {
						slidesPerView: 3
					},
					992: {
						slidesPerView: 4
					}
				},
				on: {
					init: function () {
						getRateElement();
					}
				}
			});

			var calendar_tab = new Swiper(".calendar-tab", {
				slidesPerView: 4,
				spaceBetween: 15,
				navigation: {
					nextEl: ".menu-button-next",
					prevEl: ".menu-button-prev"
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 15
					},
					992: {
						slidesPerView: 3,
						spaceBetween: 15
					}
				},
				on: {
					init: function () {
						getRateElement();
						//check show/hide navigation
						var se = $(".calendar-tab .swiper-wrapper").children([".swiper-slide"]).length;
						if (se <= 4) {
							$(".menu-button-next,.menu-button-prev").hide();
						} else {
							$(".menu-button-next,.menu-button-prev").show();
						}
						// end check show/hide navigation
					}
				}
			});
		}

		// Swiper js
		function press_hover() {
			$(".new-wrapper__lists__post").each(function () {
				$(this).hover(
					function () {
						$(this)
							.find(".btn-more__link")
							.fadeIn(500);
					},
					function () {
						$(this)
							.find(".btn-more__link")
							.hide();
					}
				);
			});
		}

		// Tab Show event
		function tab_show() {

			$('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
				getRateElement();

				$(".calendar-wrapper__body .tab-pane").each(function (index) {
					if ($(this).hasClass('active')) {
						var calendar_content = new Swiper(".calendar_content" + index, {
							slidesPerView: 5,
							navigation: {
								nextEl: ".s-next" + index,
								prevEl: ".s-prev" + index
							},
							breakpoints: {
								640: {
									slidesPerView: 2
								},
								992: {
									slidesPerView: 3
								},
								1366: {
									slidesPerView: 4
								}
							},
							on: {
								init: function () {
									getRateElement();
								}
							}
						});
					}
				});
			});

			var calendar_content = new Swiper(".calendar_content0", {
				slidesPerView: 5,
				navigation: {
					nextEl: ".s-next0",
					prevEl: ".s-prev0"
				},
				breakpoints: {
					640: {
						slidesPerView: 2
					},
					992: {
						slidesPerView: 3
					},
					1366: {
						slidesPerView: 4
					}
				},
				on: {
					init: function () {
						getRateElement();
					}
				}
			});

			$('#nav-tab .swiper-slide a').click(function () {
				$('#nav-tab .swiper-slide a').removeClass('active');
			});
		}

		// Change Lang
		function change_lang() {
			$("header .language a").each(function () {
				$(this).on("click", function () {
					if ($(this).hasClass("active")) {
					} else {
						$("header .language a").removeClass("active");
						$(this).addClass("active");
					}
				});
			});
		}

		// Limit the number of lines
		function clamp_content() {
			$(".new-wrapper__highlights--content p").css({
				display: "-webkit-box",
				"-webkit-box-orient": "vertical",
				"-webkit-line-clamp": "4"
			});
			$(".new-wrapper__lists__post .content-post").css({
				display: "-webkit-box",
				"-webkit-box-orient": "vertical",
				"-webkit-line-clamp": "3"
			});
			$(".gallery-thumbs__content .txt p").css({
				display: "-webkit-box",
				"-webkit-box-orient": "vertical",
				"-webkit-line-clamp": "4"
			});
		}

		//Back To Top
		function backToTop() {
			$("#back-to-top").hide();
			$(window).scroll(function () {
				if ($(this).scrollTop() > 800) {
					$("#back-to-top").fadeIn();
				} else {
					$("#back-to-top").fadeOut();
				}
			});
			$("#back-to-top").click(function () {
				$("html, body").animate({ scrollTop: 0 }, 1000);
			});
		}

		// Nav Section
		function navSection() {
			var menuItems;
			var scrollItems;
			var topMenu = $(".nav-natigation-right .menu-main-menu  ul"),
				offset = 200,
				topMenuHeight = topMenu.outerHeight() + offset;

			menuItems = topMenu.find('a[href*="#"]');
			scrollItems = menuItems.map(function () {
				var href = $(this).attr("href"),
					id = href.substring(href.indexOf("#")),
					item = $(id);
				if (item.length) {
					return item;
				}
			});

			// so we can get a fancy scroll animation
			menuItems.click(function (e) {
				var target = $(this).attr("href");
				$("html, body")
					.stop()
					.animate(
						{
							scrollTop: $(target).offset().top
						},
						1000
					);
				e.preventDefault();
			});

			// Bind to scroll
			$(window).scroll(function () {
				var fromTop = $(this).scrollTop() + topMenuHeight;
				var cur = scrollItems.map(function () {
					if ($(this).offset().top < fromTop) return this;
				});

				// Get the id of the current element
				cur = cur[cur.length - 1];
				var id = cur && cur.length ? cur[0].id : "";
				var idName = cur && cur.length ? cur.selector : "";
				menuItems.parent().removeClass("active");
				if (id) {
					menuItems
						.parent()
						.end()
						.filter("[href*='#" + id + "']")
						.parent()
						.addClass("active");
				}
				if ($(idName).hasClass("has-blue")) {
					$(".nav-natigation-right").addClass("nav-blue");
				} else {
					$(".nav-natigation-right").removeClass("nav-blue");
				}
			});
		}
		function masonryJS() {
			var $container = $(".custom-container");

			$container.masonry({
				itemSelector: ".item"
			});
			$(window).on("load", function () {
				$(".container").masonry({
					columnWidth: ".grid-sizer",
					gutter: 15,
					itemSelector: ".item",
					percentPosition: "true",
					fitWidth: true
				});
			});
		}

		function popup_main() {

			setTimeout(function () {
				if (typeof $.fancybox !== "undefined" && $('#iframe_show_first').length > 0) {
					$.fancybox.open({
						src: '#iframe_show_first',
						opts: {
							toolbar: false,
							smallBtn: true,
							iframe: {
								preload: false
							},
							autoFocus: false,
							btnTpl: {
								smallBtn:
									'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
									'<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
									'</button>' +
									'<div class="fancybox-close-btn">' +
									'<div id="btn-closeIn"></div>' +
									'<div id="btn-closeOut"></div>' +
									'</div>'
							},
							afterShow: function () {

								var animation3 = lottie.loadAnimation({
									container: document.getElementById("btn-closeIn"),
									renderer: "svg",
									autoplay: true,
									path: "json/Close_in.json"
								});

								var animation4 = lottie.loadAnimation({
									container: document.getElementById("btn-closeOut"),
									renderer: "svg",
									autoplay: false,
									path: "json/Close_out.json"
								});

								$("#btn-closeIn").show();
								$("#btn-closeOut").hide();

								$(".fancybox-close-btn").hover(
									function () {
										$("#btn-closeIn").hide();
										$("#btn-closeOut").show();
										animation3.stop();
										animation4.play();
									},
									function () {
										$("#btn-closeIn").show();
										$("#btn-closeOut").hide();
										animation3.play();
										animation4.stop();
									}
								);

								getRateElement();
							}
						},
					});
					$('.fancybox-close-btn').on("click", function () {
						console.log('click');
						$.fancybox.close();
					});
				}

			}, 1000);
		}

		$(window).resize(function () {
			function init_resize() {
				getRateElement();
			}
			masonryJS();
			init_resize();
		});
	});
})(jQuery);
